const state = {
  deviceInfo: null,
  softUpdateStatus: 0, //0.无需更新 1.开始检查更新 2.检查更新出错 3.需要更新 4.更新下载中 5.更新下载完成
  firmwareUpdateProcess: 0,
};

const mutations = {
  SET_DEVICEINFO: (state, deviceInfo) => {
    state.deviceInfo = deviceInfo;
  },
  DISCONNECT: (state) => {
    state.deviceInfo = null;
    state.firmwareUpdateProcess = 0;
  },
  SET_FIRMWAREUPDATE_PROGRESS: (state, firmwareUpdateProcess) => {
    state.firmwareUpdateProcess = firmwareUpdateProcess;
  },
};
const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
